import { configureStore } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import astrologicalReducer from "./slice";
import rootSaga from "./sagas";

let sagamiddleware = createSagaMiddleware();
const middleware = [sagamiddleware];

export default configureStore({
  reducer: {
    astrologicalSlice: astrologicalReducer
  },
  middleware: (getdefaultMiddleware) => {
    return getdefaultMiddleware().concat(middleware);
  }
});

sagamiddleware.run(rootSaga);
